export const DashboardHaeder = 'How to use  your dashboard'
export const ChooseTopic = 'Choose a topic'
export const DashboardHome = "1. Dashboard Home"
export const MainNavigation = "2. Main Navigation"
export const UsingFilters = "3. Using Filters"
export const AttendedClean = "4. Attended Clean"
export const MissedClean = "5. Missed Clean"
export const DashboardHomeHead = "On the dashboard you’ll see an overview of how Visit is being used. You can use the filters to take a closer look specific data sets."
export const DashboardHomeP1 = "Total number of cleaner visits - The most frequent visitors to store broken down by type."
export const DashboardHomeP2 = "Total number of cleaner visits - The number of visitors who sign themselves out, compared to the number of visitors the system automatically signs out.The system signs visitors"
export const Widget = "Widget -"
export const MainNavHead = "The main navigation bar has links to the 'Main Dashboard' and 'Config Panel."
export const MainNavP1 = "Visit Dashboard -"
export const MainNavP2 = "This is the main dashboard that show all the data captured by the Visit App."
export const MainNavP3 = "Config Panel -"
export const MainNavP4 = "Visible only to superadmin and vendoradmin."
export const FilterHead = "Example:-"
export const FilterP1 = "If you selected South as your division, London as your region and Stratford as your Area, then if you selected your date range from 1st of June 2019 to 15th of June 2019. The data you'll see under all tabs such as enforcement or cleaning will be for your selected filters i.e. Stratford and for the duration of 15 days."
export const FilterP2 = "You can apply filters to see specific sets of data. You can filter by:."
export const FilterP3 = "Stores"
export const FilterP4 = "Dates"
export const FilterP5 = "Once you’ve applied a filter it will adapt the data you see in all areas of the dashboard."
export const FilterP6 = "Access to filters"
export const FilterP7 = "The types of filters you can see depends on your job role. If you think you need to change your user rights you should email"
export const FilterP8 = "Coop Admin team."
export const AttendedHead = "Search:"
export const AttendedP1 = "You can search the records by name, company name."
export const AttendedP2 = "Download CSV:"
export const AttendedP3 = "You can download a copy of the data."
export const MissedP1 = "You can search the records by Hub Id or Hub Name."
export const BackToTop = "Back to top"
